module.exports = __webpack_public_path__ + "static/media/galerija_2019 (16).b6567f07.jpg";